import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Flex,
  Input,
  Button,
  Checkbox,
  useToast,
} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import styles from './subscribe-modal.module.scss';
import { useDispatch } from 'react-redux';
import { subscribeToNewsLatterHandler } from '../../redux/userSlice';

const SubscribeModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();
  const toast = useToast();

  const allowSubscribe = () => {
    if (!email) {
      return toast({
        title: 'Please enter email',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
    // check if email is valid using regex it should be proper email like example@gmail.com
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(?!co$)[a-zA-Z]{2,}$/i;


   
    if (!emailRegex.test(email)) {
      return toast({
        title: 'Please enter a valid email',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }

    setIsLoading(true);
    const payload = { email };
    dispatch(subscribeToNewsLatterHandler(payload)).then((res) => {
      if (res.status === 200) {
        toast({
          title: 'Subscribed Successfully',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });

        localStorage.setItem('subscribed', 'true');

        onClose();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast({
          title: res?.response?.data?.message ?? 'Something went wrong',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      }
    });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        outline={'none'}
        border={'0'}
        bg='radial-gradient(66.48% 66.48% at 50% 33.52%, #FC9B74 20.6%, #F41106 100%);
'
        boxShadow={'20px 20px 20px 0px #00000014'}
        borderRadius={'22px'}
        padding={{ base: '25px', md: '40px' }}
        w={{ base: '520px', md: '824px' }}
        minW={{ base: 'calc(100% - 50px)', md: '824px' }}
        mr={{ base: '30px', md: '0' }}
        ml={{ base: '30px', md: '0' }}
      >
        <ModalCloseButton
          bg='#E5E5E5'
          height={{ base: '20px', md: '24px' }}
          width={{ base: '20px', md: '24px' }}
          borderRadius={'50%'}
        />

        <ModalBody
          borderRadius={'22px'}
          bg='#fff'
          boxShadow={'6px 8px 4px 0px #00000040'}
          padding={{ base: '20px 22px', md: '55px 76px' }}
          className='subscribe-modal'
        >
          <Flex
            flexDir={{ base: 'column', md: 'row' }}
            gap={{ base: '10px', md: '30px' }}
            align={{ base: 'center', md: 'flex-end' }}
          >
            <Box>
              <Text
                align={{ base: 'center', md: 'inherit' }}
                fontSize={'24px'}
                fontWeight={600}
                mb={{ base: '10px', md: '0' }}
              >
                Sign up to get
              </Text>
              <Text
                fontWeight={900}
                lineHeight={'82px'}
                fontSize={{ base: '85px', md: '96px' }}
                color={'#F41106'}
              >
                15%
              </Text>
            </Box>
            <Box>
              <Text fontSize={'20px'} fontWeight={500}>
                off your first order{' '}
              </Text>
            </Box>
          </Flex>
          <Flex
            flexDir={{ base: 'column', md: 'row' }}
            mt={{ base: '25px', md: '34px' }}
            align={'center'}
            gap={'20px'}
          >
            <Input
              onChange={(e) => setEmail(e.target.value)}
              placeholder='email@example.com'
            />
            <Button
              isLoading={isLoading}
              loadingText={'Please wait...'}
              onClick={allowSubscribe}
              bg='#000'
            >
              Subscribe
            </Button>
          </Flex>
          <Text
            fontSize={'13px'}
            fontWeight={400}
            mt={{ base: '20px', md: '51px' }}
          >
            By registering, you agree to our{' '}
            <NavLink
              to={'/privacy-policy'}
              style={{ textDecorationLine: 'underline' }}
            >
              Privacy Policy
            </NavLink>{' '}
            and
            <NavLink
              to={'/terms-and-conditions'}
              style={{ textDecorationLine: 'underline' }}
            >
              {' '}
              Terms & Conditions
            </NavLink>
          </Text>
          <Checkbox
            className={styles.checkbox}
            alignItems={'flex-start'}
            isChecked={true}
            mt={{ base: '20px', md: '30px' }}
          >
            I'd like to receive exclusive offers and kwelibuy news by email.I
            understand I can contact kwelibuy to unsubscribe at anytime
          </Checkbox>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SubscribeModal;
